import { render, staticRenderFns } from "./CourseStructure.vue?vue&type=template&id=ec8c511e"
import script from "./CourseStructure.vue?vue&type=script&lang=js"
export * from "./CourseStructure.vue?vue&type=script&lang=js"
import style0 from "./CourseStructure.vue?vue&type=style&index=0&id=ec8c511e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports